import SEOText from './SEOText.vue'

export default SEOText
